import React from 'react';
import { useNavigate } from 'react-router-dom';
import { solutionColors } from '../styles/solutions';
import ProductHero from '../components/ProductPage/ProductHero';
import FeaturesSection from '../components/ProductPage/FeaturesSection';
import BenefitsSection from '../components/ProductPage/BenefitsSection';
import CTASection from '../components/ProductPage/CTASection';
import {
  ConsultingIcon,
  StrategyIcon,
  ArchitectureIcon,
  GovernanceIcon,
  DataPipelineIcon,
  SecurityIcon,
  SpeedIcon,
  InsightIcon,
} from '../components/ProductPage/icons';

const ConsultoriaPage: React.FC = () => {
  const navigate = useNavigate();
  const color = solutionColors.consultoria;

  const scrollToContact = () => {
    navigate('/contato');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goToHome = () => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById('solutions');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  const features = [
    {
      icon: <StrategyIcon />,
      title: 'Estratégia em IA e Dados',
      description: 'Desenvolvemos roadmaps personalizados alinhados aos objetivos de negócio, priorizando iniciativas com maior potencial de ROI.',
    },
    {
      icon: <ArchitectureIcon />,
      title: 'Arquitetura de Dados',
      description: 'Projetamos arquiteturas escaláveis e resilientes, desde data lakes modernos até pipelines de dados em tempo real.',
    },
    {
      icon: <GovernanceIcon />,
      title: 'Governança e LGPD',
      description: 'Implementamos frameworks de governança robustos, garantindo conformidade com LGPD e melhores práticas de segurança.',
    },
  ];

  const benefits = [
    {
      icon: <DataPipelineIcon />,
      title: 'Pipelines Modernos',
      description: 'Infraestrutura de dados otimizada para coleta, processamento e disponibilização de dados com alta confiabilidade.',
    },
    {
      icon: <SecurityIcon />,
      title: 'Segurança de Dados',
      description: 'Implementação de controles de acesso, criptografia e auditoria para garantir a proteção dos seus dados mais sensíveis.',
    },
    {
      icon: <SpeedIcon />,
      title: 'Time-to-Market Reduzido',
      description: 'Acelere a entrega de projetos de dados e IA com metodologias ágeis e frameworks comprovados.',
    },
    {
      icon: <InsightIcon />,
      title: 'Cultura Data-Driven',
      description: 'Capacitamos times e construímos uma cultura orientada a dados, garantindo sustentabilidade de longo prazo.',
    },
  ];

  return (
    <>
      <ProductHero
        icon={<ConsultingIcon />}
        title="<span class='highlight'>Consultoria & Dados</span><br />para decisões estratégicas"
        subtitle="Transforme dados em ativos estratégicos para seu negócio"
        description="Oferecemos consultoria especializada em estratégia de IA, arquitetura de dados e governança. Desde a definição de roadmap até a implementação de infraestruturas modernas, ajudamos empresas a construir capacidades sólidas em dados e IA com conformidade LGPD."
        color={color}
        onPrimaryClick={scrollToContact}
        primaryButtonText="Fale Conosco"
      />

      <FeaturesSection
        title="Consultoria estratégica completa"
        subtitle="Da estratégia à execução, construímos bases sólidas"
        features={features}
        color={color}
      />

      <BenefitsSection
        title="Construa capacidades duradouras"
        subtitle="Invista em fundações sólidas para crescimento sustentável"
        benefits={benefits}
        color={color}
      />

      <CTASection
        title="Construa uma estratégia vencedora em dados"
        description="Converse com nossos consultores e descubra como podemos ajudar sua empresa a construir capacidades sólidas em IA e dados."
        color={color}
        primaryButtonText="Agendar Conversa"
        secondaryButtonText="Ver Outras Soluções"
        onPrimaryClick={scrollToContact}
        onSecondaryClick={goToHome}
      />
    </>
  );
};

export default ConsultoriaPage;


